import { gql } from "@apollo/client";

export const EXPORT_STATUS_SUBSCRIPTION = gql`
  subscription genericSubscription($id: String!) {
    genericSubscription(topic: $id)
  }
`;
